import { FaEye, FaRegEdit, FaTrashAlt, FaPlus } from "react-icons/fa";
import Pagination from '@mui/material/Pagination';
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import ButtonIcon from "components/ButtonIcon";
import FormSearch from "components/FormSearch";
import TableComponent from "components/Table";
import { CustomerWrapper } from "./styled"
import { authSelector, customerSelector } from 'redux/selector'
import { customerActions } from 'redux/slice/customerSlice'
import useDebounce from 'hooks/useDebounce'
import AdminModalEditAccount from "../components/AdminModalEditAccount"
import Loading from "components/Loading";

const Customer = () => {
    document.title = 'Quản lý khách hàng'
    const location = useLocation()
    const query = new URLSearchParams(location.search)
    const qPage = query.get("page")
    const navigate = useNavigate()

    const [showModal, setShowModal] = useState(false)
    const [currentPage, setCurrentPage] = useState(qPage ? parseInt(qPage) : 1)
    const [sex, setSex] = useState('all')
    const [queryInput, setQueryInput] = useState('')
    const customerState = useSelector(customerSelector)
    const dispatch = useDispatch()
    const querySearch = useDebounce(queryInput, 500)
    const [method, setMethod] = useState('add')
    const [selectedId, setSelectedId] = useState(null)
    const [totalItemInPage, setTotalItemInPage] = useState(0)
    const typeModal = 'customer'

    useEffect(() => {
        dispatch(customerActions.getCustomer({ query: querySearch, sex: sex, currentPage: currentPage }))
    }, [querySearch, sex, currentPage, dispatch])

    const handleChangeSex = (e) => {
        if (currentPage > 1) {
            setCurrentPage(1)
            navigate(`/admin/customer?page=1`)
        }
        setSex(e.target.value);
    }
    const handleChangeSearchInput = (e) => {
        if (currentPage > 1) {
            setCurrentPage(1)
            navigate(`/admin/customer?page=1`)
        }
        setQueryInput(e.target.value)
    }
    const handleChangePaginate = (event, pageNumber) => {
        setCurrentPage(pageNumber)
        navigate(`/admin/customer?page=${pageNumber}`)
    }

    const handleHiddenForm = () => {
        setSelectedId(null)
        setShowModal(!showModal)
    }

    const handleShowDetailModal = (selectedId) => {
        setSelectedId(selectedId)
        setMethod('show')
        setShowModal(!showModal)
    }

    const handleShowUpdateModal = (selectedId) => {
        setSelectedId(selectedId)
        setMethod('update')
        setShowModal(!showModal)
    }

    const handleShowRemoveModal = (selectedId) => {
        setSelectedId(selectedId)
        setMethod('remove')
        setShowModal(!showModal)
    }

    const columns = [
        {
            title: 'Mã khách hàng',
            dataIndex: 'account_id',
            key: 'account_id',
        },
        {
            title: 'Tên tài khoản',
            dataIndex: 'account_name',
            key: 'account_name',
        },
        {
            title: 'Họ và tên',
            dataIndex: 'full_name',
            key: 'full_name',
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'Điện thoại',
            dataIndex: 'phone_number',
            key: 'phone_number',
        },
        {
            title: 'Giới tính',
            key: 'sex',
            dataIndex: 'sex',
            render: (_, { sex }) => (
                // eslint-disable-next-line eqeqeq
                sex == 0 ? 'Nam' : sex == 1 ? 'Nữ' : sex == 2 ? "Khác" : ""
            ),
        },
        {
            title: 'Trạng thái',
            key: 'status',
            dataIndex: 'status',
            render: (_, { status }) => (
                // eslint-disable-next-line eqeqeq
                status == 0 ? 'Hoạt động' : 'Khóa'
            ),
        },
        {
            title: 'Hoạt động',
            key: 'created_at',
            dataIndex: 'created_at',
        },
        {
            title: 'Thao tác',
            key: 'action',
            align: 'center',
            render: (_, { account_id }) => (
                <>
                    {/* <ButtonIcon
                        onClick={() => handleShowDetailModal(account_id)}
                        icon={<FaEye />}
                        description='Chi tiết'
                        classButton="action-primary btn-action"
                    /> */}
                    <ButtonIcon
                        onClick={() => handleShowUpdateModal(account_id)}
                        icon={<FaRegEdit />}
                        description='Sửa'
                        classButton="action-danger-2 btn-action"
                    />
                    <ButtonIcon
                        onClick={() => handleShowRemoveModal(account_id)}
                        icon={<FaTrashAlt />}
                        description='Xóa'
                        classButton="action-danger btn-action"

                    />
                </>
            ),
        },
    ];

    useMemo(() => {
        if (currentPage > 1) {
            setTotalItemInPage((currentPage - 1) * 5 + customerState.customerList.length)
        }
        else {
            setTotalItemInPage(customerState.customerList.length)
        }
    }, [currentPage, customerState.customerList.length])



    return (
        <CustomerWrapper className="admin_customer">
            <div className="admin_customer_control py-0 px-15">
                <FormSearch
                    placeholder='Tìm kiếm khách hàng...'
                    queryInput={queryInput}
                    onChange={handleChangeSearchInput}
                    setQueryInput={setQueryInput}
                />
                <div className="admin_customer_control_sort-add">
                    <select className="mr-15 px-10" onChange={handleChangeSex}>
                        <option value='all'>Toàn bộ</option>
                        <option value='0'>Nam</option>
                        <option value='1'>Nữ</option>
                        <option value='2'>Khác</option>
                    </select>
                </div>
            </div>
            <div className="admin_customer_table">
                {
                    customerState.isFetching &&
                    < Loading />
                }
                <TableComponent
                    columns={columns}
                    data={customerState?.customerList}
                />
            </div>
            {
                customerState?.customerList?.length > 0 &&
                <div className="admin_customer_pagination mt-15 px-15">
                    <span className="admin_customer_pagination_total_item medium">
                        {totalItemInPage} /   {customerState.totalItem}
                    </span>
                    {
                        customerState.totalPage > 1 &&
                        <Pagination count={customerState.totalPage} color="primary"
                            onChange={(event, pageNumber) => handleChangePaginate(event, pageNumber)}
                            page={currentPage}
                        />
                    }
                </div>
            }

            <AdminModalEditAccount
                typeModal={typeModal}
                selectedId={selectedId}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                querySearch={querySearch}
                sex={sex}
                showModal={showModal}
                hidden={handleHiddenForm}
                method={method}
            />

        </CustomerWrapper>
    );
}

export default Customer;